import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../shared/authentication.service';
import { Subscription } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { ApiService } from '../shared/api.service';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit, OnDestroy {
  authSubscription: Subscription; // Subscription to the authentication service
  userData; // User data
  userRecord; // User record
  idToken; // Firebase ID token
  orgData; // Organization data
  orgId: string; // Organization ID
  loading = true; // Loading flag
  isInOrg = false; // Flag to determine if user is in an organization
  isSharingLocation: boolean; // Flag to determine if sharing location is enabled
  isAdmin; // Flag to determine if user is an admin
  isOrgAdmin; // Flag to determine if user is an organization admin

  constructor(public authenticationService: AuthenticationService,
              private angularFireAuth: AngularFireAuth,
              private router: Router,
              private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.authSubscription = this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        this.userData = user; // save user data
        this.isAdmin = this.authenticationService.isAdmin; // save admin status
        this.isOrgAdmin = this.authenticationService.isOrgAdmin; // save org admin status

        const token = await user.getIdTokenResult();
        this.idToken = token.token;

        this.userRecord = this.authenticationService.userFirestoreData; // save user record
        this.orgId = this.userRecord.data.orgId || this.userRecord.data.orgData?.orgId; // save org id

        // if user is in an org, get org data
        if (this.orgId) {
          this.isInOrg = true;
          this.orgData = await this.apiService.getOrgData(this.idToken, this.orgId);
          this.isSharingLocation = this.orgData.sharingLocations; // save sharing locations status
        }
        this.loading = false;
      }
    });

  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe(); // unsubscribe from auth state
  }

  /**
   * Updates sharing locations status
   */
  async handleShareLocation(): Promise<void> {
    this.isSharingLocation = !this.isSharingLocation; // toggle sharing locations status

    // update org data
    const data = {
      sharingLocations: this.isSharingLocation
    };
    await this.apiService.updateOrgData(this.idToken, this.orgId, data);
  }
}
